import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useGridApiContext, useGridSelector, gridFilterModelSelector } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

export const createCustomFilterPanel = (filters) => {
  return function CustomFilterPanel() {
    const { t } = useTranslation();
    const apiRef = useGridApiContext();

    const filterModel = useGridSelector(apiRef, gridFilterModelSelector);

    const getCurrentValue = (field) => {
      return filterModel.items.find((item) => item.field === field)?.value || 'all';
    };

    const handleFilterChange = (field, value) => {
      const otherFilters = filterModel.items.filter((item) => item.field !== field);

      if (!value || value === 'all') {
        apiRef.current.setFilterModel({ items: otherFilters });
      } else {
        apiRef.current.setFilterModel({
          items: [
            ...otherFilters,
            {
              field,
              operator: filters.find((f) => f.field === field)?.operator || 'equals',
              value,
            },
          ],
        });
      }
    };

    return (
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {filters.map((filter) => (
          <Box key={filter.field}>
            <Typography sx={{ mb: 1 }}>{filter.label}</Typography>
            <ToggleButtonGroup
              value={getCurrentValue(filter.field)}
              exclusive
              onChange={(_, value) => handleFilterChange(filter.field, value)}
              size="small"
            >
              <ToggleButton value="all">{t('common.all')}</ToggleButton>
              {filter.options.map((option) => (
                <ToggleButton key={option.value} value={option.value}>
                  {option.label}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        ))}
      </Box>
    );
  };
};
